import { gql } from "@apollo/client";export default gql`mutation IncrementSetDuration($duration: Int!, $id: Int!) {
    update_set_by_pk(pk_columns: { id: $id }, _inc: { duration: $duration }) {
        id
    }
}
`;
